import {
  UPDATE_APPROVAL_COUNT,
  UPDATE_APPROVAL_LIST,
  UPDATE_CURRENT_APPROVAL,
  CHANGE_CURRENT_APPROVAL,
  CHANGE_CURRENT_APPROVAL_START,
  CHANGE_CURRENT_APPROVAL_SUCCESS,
  RESET_CURRENT_APPROVAL,
  CLEAR_APPROVAL_LIST,
  FETCH_APPROVALS,
  FETCH_APPROVALS_START,
  FETCH_APPROVALS_SUCCESS,
  FETCH_APPROVALS_ERROR,
  POST_APPROVAL_REJECT,
  POST_APPROVAL_REJECT_START,
  POST_APPROVAL_REJECT_SUCCESS,
  POST_APPROVAL_REJECT_ERROR,
  POST_APPROVAL_ACCEPT,
  POST_APPROVAL_ACCEPT_START,
  POST_APPROVAL_ACCEPT_SUCCESS,
  POST_APPROVAL_ACCEPT_ERROR,
  POST_APPROVAL_SKIP,
  POST_APPROVAL_SKIP_START,
  POST_APPROVAL_SKIP_SUCCESS,
  POST_APPROVAL_SKIP_ERROR,
  RESET_PRODUCT_CATEGORY_FILTER,
  UPDATE_PRODUCT_CATEGORY_FILTER,
  CHANGE_PRODUCT_CATEGORY_FILTER,
  APPROVAL_PAGE_MOUNT,
  APPROVAL_PAGE_UNMOUNT,
  REMOVE_APPROVAL,
  FETCH_APPROVAL_COUNT,
  FETCH_APPROVAL_COUNT_START,
  FETCH_APPROVAL_COUNT_SUCCESS,
  FETCH_APPROVAL_COUNT_ERROR,
} from './constants'
import {
  buildAsyncAction,
} from 'containers/Async/actions'

const removeApproval = (approval) => ({ type: REMOVE_APPROVAL, approval })
const approvalPageMount = () => ({ type: APPROVAL_PAGE_MOUNT })
const approvalPageUnmount = () => ({ type: APPROVAL_PAGE_UNMOUNT })
const updateCurrentApproval = (approval) => ({ type: UPDATE_CURRENT_APPROVAL, approval })
const changeCurrentApproval = (approval) => ({ type: CHANGE_CURRENT_APPROVAL, approval })
const changeCurrentApprovalStart = () => ({ type: CHANGE_CURRENT_APPROVAL_START })
const changeCurrentApprovalSuccess = (approval) => ({ type: CHANGE_CURRENT_APPROVAL_SUCCESS, approval })
const updateApprovalList = (approvals) => ({ type: UPDATE_APPROVAL_LIST, approvals })
const resetCurrentApproval = () => ({ type: RESET_CURRENT_APPROVAL })
const resetProductCategoryFilter = () => ({ type: RESET_PRODUCT_CATEGORY_FILTER })
const updateProductCategoryFilter = (filter) => ({ type: UPDATE_PRODUCT_CATEGORY_FILTER, filter })
const changeProductCategoryFilter = (filter) => ({ type: CHANGE_PRODUCT_CATEGORY_FILTER, filter })
const clearApprovalList = () => ({ type: CLEAR_APPROVAL_LIST })
const fetchApprovals = () => ({ type: FETCH_APPROVALS })
const fetchApprovalsStart = () => ({ type: FETCH_APPROVALS_START })
const fetchApprovalsSuccess = (approvals) => ({ type: FETCH_APPROVALS_SUCCESS, approvals })
const fetchApprovalsError = (error) => ({ type: FETCH_APPROVALS_ERROR, error })
const postApprovalRejectStart = () => ({ type: POST_APPROVAL_REJECT_START })
const postApprovalRejectSuccess = () => ({ type: POST_APPROVAL_REJECT_SUCCESS })
const postApprovalRejectError = (error) => ({ type: POST_APPROVAL_REJECT_ERROR, error })
const postApprovalAcceptStart = () => ({ type: POST_APPROVAL_ACCEPT_START })
const postApprovalAcceptSuccess = () => ({ type: POST_APPROVAL_ACCEPT_SUCCESS })
const postApprovalAcceptError = (error) => ({ type: POST_APPROVAL_ACCEPT_ERROR, error })
const postApprovalSkipStart = () => ({ type: POST_APPROVAL_SKIP_START })
const postApprovalSkipSuccess = () => ({ type: POST_APPROVAL_SKIP_SUCCESS })
const postApprovalSkipError = (error) => ({ type: POST_APPROVAL_SKIP_ERROR, error })
const postApprovalReject = (workflowId, approverWorkflowStateId, comment) => ({
  type: POST_APPROVAL_REJECT,
  workflowId,
  approverWorkflowStateId,
  comment
})
const postApprovalAccept = (workflowId, approverWorkflowStateId) => ({
  type: POST_APPROVAL_ACCEPT,
  workflowId,
  approverWorkflowStateId
})
const postApprovalSkip = (workflowId, approverWorkflowStateId, approvalType) => ({
  type: POST_APPROVAL_SKIP,
  workflowId,
  approverWorkflowStateId,
  approvalType
})
const fetchApprovalCount = () => ({ type: FETCH_APPROVAL_COUNT })
const fetchApprovalCountStart = () => ({ type: FETCH_APPROVAL_COUNT_START })
const fetchApprovalCountSuccess = () => ({ type: FETCH_APPROVAL_COUNT_SUCCESS })
const fetchApprovalCountError = (error) => ({ type: FETCH_APPROVAL_COUNT_ERROR, error })
const updateApprovalCount = (count) => ({ type: UPDATE_APPROVAL_COUNT, count })

const startFetchApprovals = buildAsyncAction(
  FETCH_APPROVALS,
  FETCH_APPROVALS_START,
  [FETCH_APPROVALS_SUCCESS, FETCH_APPROVALS_ERROR]
)

export {
  removeApproval,
  approvalPageMount,
  approvalPageUnmount,
  changeProductCategoryFilter,
  resetProductCategoryFilter,
  updateProductCategoryFilter,
  updateCurrentApproval,
  updateApprovalCount,
  changeCurrentApproval,
  changeCurrentApprovalStart,
  changeCurrentApprovalSuccess,
  updateApprovalList,
  resetCurrentApproval,
  clearApprovalList,
  startFetchApprovals,
  fetchApprovals,
  fetchApprovalsStart,
  fetchApprovalsSuccess,
  fetchApprovalsError,
  postApprovalReject,
  postApprovalRejectStart,
  postApprovalRejectSuccess,
  postApprovalRejectError,
  postApprovalSkip,
  postApprovalAccept,
  postApprovalAcceptStart,
  postApprovalAcceptSuccess,
  postApprovalAcceptError,
  fetchApprovalCount,
  fetchApprovalCountStart,
  fetchApprovalCountSuccess,
  fetchApprovalCountError,
  postApprovalSkipStart,
  postApprovalSkipSuccess,
  postApprovalSkipError,
}
